import { useContext } from 'react';

import { Button } from 'antd';

import { FormGroupContext } from '@/components/FormGroup';
import FiscalTerm from '@/components/wizard/FiscalTerm';
import ProducerAddress from '@/components/wizard/ProducerAddress';
import ProducerCellPhone from '@/components/wizard/ProducerCellPhone';
import ProducerDocument from '@/components/wizard/ProducerDocument';
import ProducerText from '@/components/wizard/ProducerText';
import UseTerm from '@/components/wizard/UseTerm';
import { trpc } from '@/lib/trpc';
import { validateFields } from '@/lib/validation';
import useProductStore from '@/stores/productStore';

import Wizard from '../..';
import { stepStore } from '../../../../../stores/steps/index';

const Details = () => {
  const producer = useProductStore(d => d.producer);

  const updateProfileMutation = trpc.myEduzz.updateProfile.useMutation();

  const { emit } = useContext(FormGroupContext);

  const submit = async () => {
    const results = await emit({ type: 'validate' });
    const allValid = validateFields(results);

    if (allValid) {
      try {
        await updateProfileMutation.mutateAsync({
          producerNative: producer.native,
          producerDocument: producer.document,
          producerZipCode: producer.zipCode,
          producerCity: producer.city,
          producerCityId: producer.cityId,
          producerState: producer.state,
          producerStreetName: producer.streetName,
          producerStreetNumber: producer.streetNumber,
          producerDistrict: producer.district,
          producerCellPhone: producer.cellPhone,
          producerFiscalTerm: producer.fiscalTerm,
          producerUseTerm: producer.useTerm,
          producerComplement: producer.complement
        });
        stepStore.getState().nextStep();
      } catch (error) {
        console.error('Mutation error:', error);
      }
    }
  };

  return (
    <div className='mt-4 mb-2 flex flex-col gap-4'>
      <ProducerDocument />
      <ProducerAddress />
      <ProducerCellPhone />
      <FiscalTerm />
      <UseTerm />

      <ProducerText />

      <Wizard.Footer closable preview>
        <Button type='primary' id='submit' onClick={submit}>
          Gostei, continuar
        </Button>
      </Wizard.Footer>
    </div>
  );
};
export default Details;
